import { FC } from 'react';

export const Logs: FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 12h.01" />
    <path d="M4 6h.01" />
    <path d="M4 18h.01" />
    <path d="M8 18h2" />
    <path d="M8 12h2" />
    <path d="M8 6h2" />
    <path d="M14 6h6" />
    <path d="M14 12h6" />
    <path d="M14 18h6" />
  </svg>
);

export default Logs;
